const TUTOR_DASHBOARD_PATH = `/tutor`;
const TUTOR_WORKSPACES_PATH = `${TUTOR_DASHBOARD_PATH}/workspaces`;
const STUDENT_DASHBOARD_PATH = `/student`;
const STUDENT_WORKSPACES_PATH = `${STUDENT_DASHBOARD_PATH}/workspaces`;

const PATHS = {
  BASE: "/",
  REDIRECT: "/redirect",
  SIGN_IN: "/sign-in",
  SIGN_UP: "/sign-up",
  LOG_OUT: "/log-out",
  TOO_MANY_REQUESTS: "/too-many-requests",
  TUTOR: {
    DASHBOARD: TUTOR_DASHBOARD_PATH,
    OVERVIEW: `${TUTOR_DASHBOARD_PATH}/overview`,
    PUBLIC_PROFILE: `${TUTOR_DASHBOARD_PATH}/profile`,
    CREATE_PROFILE: `${TUTOR_DASHBOARD_PATH}/create-profile`,
    CREATE_PROFILE_NL: `${TUTOR_DASHBOARD_PATH}/create-profile/new-locale`,
    CHAT: `${TUTOR_DASHBOARD_PATH}/chat`,
    CALENDAR: `${TUTOR_DASHBOARD_PATH}/schedule/calendar`,
    SCHEDULE: {
      INDEX: `${TUTOR_DASHBOARD_PATH}/schedule`,
      TEMPLATES: `${TUTOR_DASHBOARD_PATH}/schedule/templates`,
      SETTINGS: `${TUTOR_DASHBOARD_PATH}/schedule/settings`,
      PRICING: `${TUTOR_DASHBOARD_PATH}/schedule/pricing`,
    },
    ONBOARDING: {
      INDEX: `${TUTOR_DASHBOARD_PATH}/onboarding`,
      PROFILE: `${TUTOR_DASHBOARD_PATH}/onboarding/profile`,
      PRICING: `${TUTOR_DASHBOARD_PATH}/onboarding/pricing`,
      PAYMENTS: `${TUTOR_DASHBOARD_PATH}/onboarding/payments`,
      INVITE: `${TUTOR_DASHBOARD_PATH}/onboarding/invite`,
    },
    FINANCES: {
      INDEX: `${TUTOR_DASHBOARD_PATH}/finances`,
      OVERVIEW: `${TUTOR_DASHBOARD_PATH}/finances/overview`,
      PAYMENTS: `${TUTOR_DASHBOARD_PATH}/finances/payments`,
      PAYMENTS_HISTORY: `${TUTOR_DASHBOARD_PATH}/finances/payments`,
      PAYMENTS_SETUP: `${TUTOR_DASHBOARD_PATH}/finances/payments-setup`,
      PAYOUTS: `${TUTOR_DASHBOARD_PATH}/finances/payouts`,
      SETTINGS: `${TUTOR_DASHBOARD_PATH}/finances/settings`,
      BUY_CREDITS: `${TUTOR_DASHBOARD_PATH}/finances/buy-credits`,
      CREDITS_HISTORY: `${TUTOR_DASHBOARD_PATH}/finances/credits-history`,
      CHECKOUT_STATUS: `${TUTOR_DASHBOARD_PATH}/finances/checkout-status`,
      PAYMENT_DETAILS: `${TUTOR_DASHBOARD_PATH}/finances/payments/:id/details`,
    },
    SUPPORT: {
      TECHNICAL: `${TUTOR_DASHBOARD_PATH}/support/technical`,
    },
    WORKSPACES: {
      WORKSPACES: `${TUTOR_WORKSPACES_PATH}`,
      LIST: `${TUTOR_WORKSPACES_PATH}/list`,
      INVITATIONS: `${TUTOR_WORKSPACES_PATH}/invitations`,
      MAIN: `${TUTOR_WORKSPACES_PATH}/main`,

      LESSON: `${TUTOR_WORKSPACES_PATH}/lesson`,
    },
  },
  STUDENT: {
    DASHBOARD: STUDENT_DASHBOARD_PATH,
    OVERVIEW: `${STUDENT_DASHBOARD_PATH}/overview`,
    CHAT: `${STUDENT_DASHBOARD_PATH}/chat`,
    FINANCES: {
      PAYMENTS: `${STUDENT_DASHBOARD_PATH}/finances/payments`,
      PAYMENT_DETAILS: `${STUDENT_DASHBOARD_PATH}/finances/payments/:id/details`,
    },
    SUPPORT: {
      TECHNICAL: `${STUDENT_DASHBOARD_PATH}/support/technical`,
    },
    WORKSPACES: {
      WORKSPACES: `${STUDENT_WORKSPACES_PATH}`,
      LIST: `${STUDENT_WORKSPACES_PATH}/list`,
      MAIN: `${STUDENT_WORKSPACES_PATH}/main`,
      JOIN: `${STUDENT_WORKSPACES_PATH}/join`,

      LESSON: `${STUDENT_WORKSPACES_PATH}/lesson`,
    },
  },
  PROFILES: {
    TUTOR_PROFILE: `/profile/tutor`,
  },
  LESSONS: {
    CLASSROOM: `/classroom`,
  },
  TERMS_OF_SERVICE: `/terms-of-service`,
  PRIVACY_POLICY: `/privacy-policy`,
} as const;

export const STUDENT_WORKSPACE_PATHS = (workspaceId: string | undefined) => {
  return {
    HOME: `${STUDENT_WORKSPACES_PATH}/${workspaceId}`,
    CHAT: `${STUDENT_WORKSPACES_PATH}/${workspaceId}/chat`,
    CHATS: `${STUDENT_WORKSPACES_PATH}/${workspaceId}/chats`,
    LESSONS: `${STUDENT_WORKSPACES_PATH}/${workspaceId}/lessons/listing`,
    LESSON_DETAILS: `${STUDENT_WORKSPACES_PATH}/${workspaceId}/lessons`,
    SCHEDULE: `${STUDENT_WORKSPACES_PATH}/${workspaceId}/schedule`,
    MATERIALS: `${STUDENT_WORKSPACES_PATH}/${workspaceId}/materials`,
    HOMEWORKS: `${STUDENT_WORKSPACES_PATH}/${workspaceId}/homeworks`,
    ANNOUNCEMENTS: `${STUDENT_WORKSPACES_PATH}/${workspaceId}/announcements`,
    SETTINGS: `${STUDENT_WORKSPACES_PATH}/${workspaceId}/settings`,
    LESSON: `${STUDENT_WORKSPACES_PATH}/${workspaceId}/lesson`,
    TUTORS: `${STUDENT_WORKSPACES_PATH}/${workspaceId}/tutors`,
  };
};

export const TUTOR_WORKSPACE_PATHS = (workspaceId: string | undefined) => {
  return {
    HOME: `${TUTOR_WORKSPACES_PATH}/${workspaceId}`,
    CHAT: `${TUTOR_WORKSPACES_PATH}/${workspaceId}/chat`,
    CHATS: `${TUTOR_WORKSPACES_PATH}/${workspaceId}/chats`,
    LESSONS: `${TUTOR_WORKSPACES_PATH}/${workspaceId}/lessons/listing`,
    LESSON_DETAILS: `${TUTOR_WORKSPACES_PATH}/${workspaceId}/lessons`,
    SCHEDULE: `${TUTOR_WORKSPACES_PATH}/${workspaceId}/schedule`,
    MATERIALS: `${TUTOR_WORKSPACES_PATH}/${workspaceId}/materials`,
    HOMEWORKS: `${TUTOR_WORKSPACES_PATH}/${workspaceId}/homeworks`,
    NOTES: `${TUTOR_WORKSPACES_PATH}/${workspaceId}/notes`,
    SETTINGS: `${TUTOR_WORKSPACES_PATH}/${workspaceId}/settings`,
    LESSON: `${TUTOR_WORKSPACES_PATH}/${workspaceId}/lesson`,
    STUDENTS: `${TUTOR_WORKSPACES_PATH}/${workspaceId}/students`,
  };
};

export default PATHS;
